// src/components/HomeComponents/FaqSection.jsx
import React, { useState } from 'react';
import '../../styles/StudentComponents/StFaqSection.css';
import { FaPlus, FaMinus } from 'react-icons/fa';

const faqData = [
  {
    question: 'What Is Strawket?',
    answer:
      'Strawket is where exceptional teaching meets unique potential in every learner. We’re a thoughtfully designed platform that connects curious minds with instructors who make learning feel like an adventure rather than a chore. Our intuitive tools make scheduling, communication, and progress tracking seamless, so you can focus on what matters—watching yourself or your child flourish.',
  },
  {
    question: 'How does Strawket benefit learners?',
    answer:
      'Strawket empowers learners by offering tailored instruction, intuitive tools, and progress tracking for a personalized experience.',
  },
  {
    question: 'Is Strawket safe?',
    answer:
      'Yes, Strawket is built with privacy and security in mind. All data is encrypted and access is role-restricted.',
  },
  {
    question: 'What support is available?',
    answer:
      'Our support team is available 24/7. We also offer live chat, helpdesk tickets, and instructor guidance.',
  },
  {
    question: 'What types of classes are available?',
    answer:
      'We offer a variety of classes including art, music, academics, coding, and more, customized to your goals.',
  },
];

const StFaqSection = () => {
  const [activeIndex, setActiveIndex] = useState(0); // first FAQ expanded

  const toggleIndex = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="st-faq-section">
      <h2 className="st-faq-title">FAQs</h2>
      <div className="st-faq-container">
        {faqData.map((faq, index) => (
          <div key={index} className="st-faq-item">
            <div
              className="st-faq-question"
              onClick={() => toggleIndex(index)}
            >
              <span>{faq.question}</span>
              {activeIndex === index ? (
                <FaMinus className="st-icon st-minus-icon" />
              ) : (
                <span className="st-icon custom-plus-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
      <line y1="14.5" x2="29" y2="14.5" stroke="#2B2730" strokeWidth="3"/>
      <line x1="14.5" y1="0" x2="14.5" y2="29" stroke="#2B2730" strokeWidth="3"/>
    </svg>
  </span>
              )}
            </div>
            {activeIndex === index && (
              <div className="st-faq-answer">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StFaqSection;
